import styled from "styled-components"

import theme from "../../../theme/"

const NAVIGATION_HEIGHT = "70px"

export const Navigation = styled.nav`
  display: inline-flex;
  position: fixed;
  top: 0;
  background: ${theme.bg.default};
  color: ${theme.brand.alt};
  z-index: 8;
  width: 100%;
  max-width: 100%;
  height: ${NAVIGATION_HEIGHT};
  justify-content: center;
  border-bottom-width: 3px;
  border-bottom-style: solid;
  border-image-slice: 1;
  border-image-source: linear-gradient(to right, 
      ${theme.brand.default}, 
      ${theme.brand.alt},
      ${theme.brand.default} 
    );
  box-shadow: 0 10px 10px -7px rgba(0,0,0,.2);
`

export const NavigationContainer = styled.div`
  display: inline-flex;
  align-items: center;
  width: 100%;
  height: 100%;
  margin: 0;
  max-width: 1440px;
  
  @media (min-width: 1024px) {
    padding: 0 30px;
  }
`

export const Contact = styled.div`
  display: none;
  
  @media (min-width: 1024px) {
    display: flex;
  }
`
